import React, { useCallback } from "react";
import { useCalculatorContext } from "../../Contexts/CalculatorContext";
const Picker = () => {
    const { currency, setCurrency, currencies } = useCalculatorContext();
    const updateCurrency = useCallback((event) => {
        const currency = event.target.value;
        setCurrency(currency);
    }, [setCurrency]);
    return (React.createElement("div", { className: "me-2" },
        React.createElement("label", { htmlFor: "currency-select", className: "currency-label" }, "Currency:"),
        React.createElement("div", { className: "currency-picker" },
            React.createElement("select", { id: "currency-select", name: "currency", value: currency, onChange: updateCurrency, className: "currency-select" }, currencies.map((currency, index) => (React.createElement("option", { key: currency.id, value: currency.alias }, currency.alias)))))));
};
export { Picker };
